import { render, staticRenderFns } from "./local-qrcode.vue?vue&type=template&id=063e77f4"
import script from "./local-qrcode.vue?vue&type=script&lang=js"
export * from "./local-qrcode.vue?vue&type=script&lang=js"
import style0 from "./local-qrcode.vue?vue&type=style&index=0&id=063e77f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports